import { styled } from '@prose-ui/legacy';

import { ReactComponent as StylingGelFramePrev } from 'assets/images/landingPages/stylingGel/arrow-left.svg';
import { ReactComponent as StylingGelFrameNext } from 'assets/images/landingPages/stylingGel/arrow-right.svg';

const CustomSliderArrowWrapper = styled.button`
  border: none;
  background: none;
`;

type SliderArrowProps = {
  direction: 'prev' | 'next';
  className?: string;
  style?: Record<string, string>;
  onClick?: () => void;
};

export const SliderArrow = ({
  className = '',
  style = {},
  onClick = undefined,
  direction,
}: SliderArrowProps) => {
  return (
    <CustomSliderArrowWrapper className={className} onClick={onClick} style={style} type="button">
      {direction === 'prev' ? <StylingGelFramePrev /> : <StylingGelFrameNext />}
    </CustomSliderArrowWrapper>
  );
};
